import { environment } from 'src/environments/environment';

export class DetalhamentoFatura {
  id: number;
  uuid: string;
  idFaturamento: number;
  uuidFaturamento: string;
  statusFaturaCliente: string;
  statusFaturaClienteNovo?: string;
  idUnidade: number;
  uuidUnidade: string;
  nomeFantasia: string;
  razaoSocial: string;
  documento: string;

  valorTotal: number;

  valorTotalMod?: string;

  linkPdf: string;
  linkXlsx: string;

  dataTransacaoNfe: string;
  idNfe: number;
  linkPdfNfe: string;
  linkXmlNfe: string;
  motivoStatusNfe: string;
  statusNfe: string;
  dataTransacaoBoleto: string;
  dataVencimentoBoleto: string;
  idBoleto: number;
  statusBoletoNovo?: string;
  linkPdfBoleto: string;
  statusBoleto: string;
  motivoStatusBoleto: string;
  codigoFaturaBoleto: string;
  codigoTransacaoBoleto: string;
  numero: string;

  dataTransacaoNfeStr?: string;
  dataTransacaoBoletoStr?: string;
  dataVencimentoBoletoStr?: string;
  statusFaturaClienteStr?: string;
  statusBoletoStr?: string;
  statusNfeStr?: string;
  check?: boolean;
  gerarNota: string;

  constructor(detalhamentoFatura) {
    this.id = detalhamentoFatura['id'] || null;
    this.uuid = detalhamentoFatura['uuid'] || null;
    this.idFaturamento = detalhamentoFatura['idFaturamento'] || null;
    this.uuidFaturamento = detalhamentoFatura['uuidFaturamento'] || null;
    this.statusFaturaCliente = detalhamentoFatura['statusFaturaCliente'] || null;
    this.idUnidade = detalhamentoFatura['idUnidade'] || null;
    this.uuidUnidade = detalhamentoFatura['uuidUnidade'] || null;
    this.nomeFantasia = detalhamentoFatura['nomeFantasia'] || null;
    this.razaoSocial = detalhamentoFatura['razaoSocial'] || null;
    this.documento = detalhamentoFatura['documento'] || null;
    this.valorTotal = detalhamentoFatura['valorTotal'] || 0;
    this.valorTotalMod = this.valorTotal.toLocaleString('pt-BR', {maximumFractionDigits:2,minimumFractionDigits:2}) || null;

    this.linkPdf = environment.wsUrl+"faturamento/pdfFaturasDetalhadoCliente/"+this.uuidFaturamento+"/"+this.uuidUnidade
    this.linkXlsx = environment.wsUrl+"faturamento/excelFaturasDetalhadoCliente/"+this.uuidFaturamento+"/"+this.uuidUnidade

    this.dataTransacaoNfe = detalhamentoFatura['dataTransacaoNfe'] || null;
    this.idNfe = detalhamentoFatura['idNfe'] || null;
    this.linkPdfNfe = detalhamentoFatura['linkPdfNfe'] || null;
    this.linkXmlNfe = detalhamentoFatura['linkXmlNfe'] || null;
    this.motivoStatusNfe = detalhamentoFatura['motivoStatusNfe'] || null;
    this.statusNfe = detalhamentoFatura['statusNfe'] || null;
    this.numero = detalhamentoFatura['numeroNfe'] || null;

    this.dataTransacaoBoleto = detalhamentoFatura['dataTransacaoBoleto'] || null;
    this.dataVencimentoBoleto = detalhamentoFatura['dataVencimentoBoleto'] || null;
    this.idBoleto = detalhamentoFatura['idBoleto'] || null;
    this.linkPdfBoleto = detalhamentoFatura['linkPdfBoleto'] || null;
    this.statusBoleto = detalhamentoFatura['statusBoleto'] || null;
    this.motivoStatusBoleto = detalhamentoFatura['motivoStatusBoleto'] || null;
    this.codigoFaturaBoleto = detalhamentoFatura['codigoFaturaBoleto'] || null;
    this.codigoTransacaoBoleto = detalhamentoFatura['codigoTransacaoBoleto'] || null;
    // this.numero = detalhamentoFatura['numero'] || null;
    this.gerarNota = detalhamentoFatura['gerarNota'] || null;


  }

}
